export default "__VITE_ASSET__BYw$SDy$__"